import client from './client';
import qs from 'qs';

/**
 * 매체 통계
 */
export const mediaStatistics = (params) =>
  client.get(`/api/report/media/mreport`, params);

/**
 * 매체 통계 웹모바일 상세
 */
export const mediaStatisticsDetail = (params) =>
  client.get(`/api/report/media/sub`, params);

/**
 * 매체통계 - 지면별 타게팅분포
 **/
export const getMediaTargetNew = (params) =>
  client.get(`/api/ch_report/media/mediatarget`, params);

/**
 * 매체통계 - 지면별 타게팅분포 - 그래프 - 지면효율등급별
 **/
export const getMediaTargetGraph = (params) =>
  client.get(`/api/ch_report/media/mediatarget/graph`, params);

/**
 * 매체통계 - 지면별 타게팅분포 - 그래프 - 지면효율등급별
 **/
export const getMediaTargetParRank = (params) =>
  client.get(`/api/ch_report/media/parRank/graph`, params);

/**
 * 매체통계 - 지면별 타게팅분포 - 그래프 - 정산방식별
 **/
export const getMediaTargetParAdut = (params) =>
  client.get(`/api/ch_report/media/parAdut/graph`, params);

/**
 * 매체통계 - 지면별 타게팅분포 - 임계치 수정
 **/
export const setParThresHold = (params) =>
  client.post(`/api/report/media/parThresHold/set`, params);

/**
 * 매체통계 - 지면별 타게팅분포 - 메모 가져오기
 **/
export const getParMemoList = (params) =>
  client.get(`/api/report/media/parMemo`, params);

/**
 * 매체통계 - 지면별 타게팅분포 - 메모 추가, 수정
 **/
export const setParMemo = (params) =>
  client.post(`/api/report/media/parMemo/set`, params);

/**
 * 매체통계 - 지면별 타게팅분포 - 메모 삭제
 **/
export const deleteParMemo = (memoNo) =>
  client.delete(`/api/report/media/parMemo/del`, {
    data: { memoNo: memoNo },
  });

/**
 * 매체통계 - 지면별 타게팅분포 - 가중치현황판리스트
 **/
export const getTargetWeight = (params) =>
  client.get(`/api/report/media/targetWeight`, params);

/**
 * 매체통계 - 지면별 타게팅분포 - 가중치현황판리스트 - 수정
 **/
export const setTargetWeight = (params) =>
  client.post(`/api/report/media/targetWeight/set`, params);

/**
 * 매체 정산 통계
 **/
export const mediaSettleStatistics = (params) =>
  client.get(`/api/report/media/macount`, params);

/**
 * 매체 정산 히스토리
 **/
export const mediaSettleHistory = (params) =>
  client.get(`/api/report/media/macount/history`, params);

/**
 * 매체 지면별 타겟팅분포
 **/
export const TargetMediaStatistics = (params) =>
  client.get(`/api/report/media/mediatarget`, params);

/**
 * 매체 운영수익
 **/
export const mediaRevenueStatistics = (params) =>
  client.get(`/api/report/media/revenue`, params);

/**
 * 매체 등락 보고
 **/
export const mediaFluctuationStatistics = (params) =>
  client.get(`/api/report/media/fluctuation`, params);

/**
 * 매체 등락 보고 - 그래프
 **/
export const mediaFluctuationStatisticsGraph = (params) =>
  client.get(`/api/report/media/fluctuation/graph`, { params: params });

/**
 * 매체 지면등락보고
 **/
export const mediaCtrStatistics = (params) =>
  client.get(`/api/report/media/scriptFluctuation`, params);

/**
 * 매체 매체지면등락보고
 **/
export const FluctuationScriptStatisticsData = (params) =>
  client.get(`/api/report/media/fluctuation`, params);

/**
 * 매체 매체지면등락보고 그래프
 **/
export const FluctuationScriptGraph = (params) =>
  client.get(`/api/report/media/fluctuation/graph`, params);

/**
 * 집중관리매체 - 매체리스트
 **/
export const mediaTopList = (params) =>
  client.get(`/api/report/media/top_list`, params);

/**
 * 집중관리매체
 **/
export const mediaTopStatistics = (params) =>
  client.get(`/api/report/media/media_top`, params);

/**
 * 집중관리매체 - 지정일기준
 **/
export const mediaDayTopStatistics = (params) =>
  client.get(`/api/report/media/mediaday_top`, params);

/**
 * 집중관리매체 - 그래프
 **/
export const mediaTopGraphStatistics = (params) =>
  client.get(`/api/report/media/media_top/graph`, { params: params });

/**
 * 매체 미노출 통계
 **/
export const mediaNoBannerStatistics = (params) =>
  client.get(`/api/report/media/nobanner`, params);

/**
 * 지면 Roas 통계
 **/
export const mediaRoasStatistics = (params) =>
  client.get(`/api/report/media/media_roas/graph`, params);

/**
 * 매체 new 매체별 통계
 **/
export const mediaNewStatistics = (params) =>
  client.get(`/api/report/media/media_new`, params);

/**
 * 매체 new 매체별 상세
 */
export const mediaNewSubStatistics = (params) =>
  client.get(`/api/report/media/media_sub`, params);

/**
 * 매체 new 지면별 통계
 **/
export const NewMediaMcStatistics = (params) =>
  client.get(`/api/report/media/media_new_mc`, params);

/**
 * 매체 지면 비교통계
 **/
export const mediaCompareStatistics = (params) =>
  client.get(`/api/report/media/media_compare`, params);

/**
 * 매체 지면 비교통계
 **/
export const noBannerPayType = (params) =>
  client.get(`/api/code/noBannerpayType`, params);

/**
 * 매체종합현황판 - PIE 그래프 데이터
 **/
export const mediaPieGraph = () =>
  client.get(`/api/report/media/board/pieGraph`);

/**
 * 매체종합현황판 - 달 소진
 **/
export const mediaThisMonthAmt = (params) =>
  client.get(`/api/report/media/board/month`, { params: params });

/**
 * 매체종합현황판 - 외부연동 테이블 데이터
 **/
export const externalTableData = (params) => {
  return client.get(`/api/report/media/board/external`, { params: params });
};

/**
 * 매체종합현황판 - 신디 테이블 데이터
 **/
export const sindyTableData = (params) =>
  client.get(`/api/report/media/board/sindy`, { params: params });

/**
 * 매체종합현황판 - 이슈 테이블 데이터
 **/
export const issueTableData = (params) =>
  client.get(`/api/report/media/board/issue`, { params: params });

/**
 * 매체종합현황판 - 지출금액 top 20 데이터
 **/
export const advrtsTableData = (params) =>
  client.get(`/api/report/media/board/advrtsTop`, { params: params });

/**
 * 매체종합현황판 - 상위 TOP 10 데이터
 **/
export const rankTableData = (params) =>
  client.get(`/api/report/media/board/rank`, { params: params });

/**
 * 매체종합현황판 - 금월 신규 매체 데이터
 **/
export const newTableData = (params) =>
  client.get(`/api/report/media/board/newMedia`, { params: params });

/**
 * 매체종합현황판 - 광고주정보
 **/
export const adverTableData = (params) =>
  client.get(`/api/report/media/board/adver`, { params: params });

/**
 * 매체종합현황판 - 담당자별 통계
 **/
export const managerTableData = (params) =>
  client.get(`/api/report/media/board/manager`, { params: params });

/**
 * 매체종합현황판 - 그래프데이터
 **/
export const boardGraphData = (params) =>
  client.get(`/api/report/media/board/graph`, params);

/**
 * 매체종합현황판 이달목표 수정
 * @param {array}
 */
export const modifyManagerGoal = (params) =>
  client.post(`/api/report/media/board/goal`, qs.stringify(params));

/**
 * 매체종합현황판 - 담당자 상세 통계 테이블
 **/
export const managerDetailTableData = (params) =>
  client.get(`/api/report/media/board/manager/detail`, { params: params });

/**
 * 매체종합현황판 - 담당자 상세 통계 그래프
 **/
export const managerDetailGraphData = (params) =>
  client.get(`/api/report/media/board/manager/detail/graph`, {
    params: params,
  });

/**
 * 매체통계 - 프레임RTB통계
 **/
export const frameSizeList = (params) =>
  client.get(`/api/report/frame/size`, params);
